import { useMutation } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useStandardClaimRequest = () => {
  return useMutation({
    mutationFn: async (claimData) => {
      const formData = new FormData();
      formData.append('policy_number', claimData.policyNumber);
      formData.append('current_cash_value', claimData.currentCashValue);
      formData.append('claim_amount', claimData.claimAmount);
      formData.append('partial_withdrawal_purpose', claimData.withdrawalPurpose);
      formData.append('payment_method', claimData.paymentMethod);
      formData.append('claim_default_telcomethod', claimData.telecomMethod);
      formData.append('claim_default_momo_wallet', claimData.momoWallet);

      // Bank details (only for Bank payment)
      if (claimData.paymentMethod === 'Bank') {
        formData.append('bank_name', claimData.bankName || '');
        formData.append('bank_account_number', claimData.bankAccountNumber || '');
        formData.append('branch_name', claimData.branchName || '');
        formData.append('bank_account_name', claimData.bankAccountName || '');
      }

      const response = await apiClient.post('/policy/standard-claim-request', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    },
  });
};

export { useStandardClaimRequest };
